import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/kit';
import { pricing } from '../data/pricing';
export function BonusesSection() {
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-21" data-mp="gxzx7dmmbdv8">
      <div className="max-w-3xl mx-auto" data-id="element-22" data-mp="vtnx4qkwletb">
        <div className="text-center mb-12" data-id="element-23" data-mp="vqjmpbguhmu7">
          <h2 className="text-3xl md:text-4xl font-black text-brand-text mb-4" data-id="element-24" data-mp="qsruegcafyph">
            5 Bonos Exclusivos
          </h2>
          <p className="text-brand-gray" data-id="element-25" data-mp="14rzt784jh4t5">
            Valorados en{' '}
            <span className="font-bold text-brand-terracotta line-through" data-id="element-26" data-mp="ztg9ledf453y">
              {pricing.bonusesValue}
            </span>{' '}
            — los llevás <strong className="text-brand-text" data-id="element-27" data-mp="1el8dmu7rhwqd">GRATIS</strong>
          </p>
        </div>

        <ul className="space-y-4" data-id="element-28" data-mp="19mdufr5vu65q">
          {bonuses.map((bonus, i) => <li key={bonus} className="bg-white rounded-2xl p-4 md:p-6 flex items-center gap-4 md:gap-6 shadow-sm border border-brand-creamDark/50" data-id="element-29" data-mp="1nkln3mvvylb3" data-mpi={i}>
              <span className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-brand-green text-white flex items-center justify-center font-bold shrink-0 text-sm md:text-base" data-id="element-30" data-mp="3prn4bwkap729">
                {i + 1}
              </span>
              <span className="w-12 h-12 md:w-16 md:h-16 bg-brand-creamDark rounded-lg shrink-0 flex items-center justify-center" data-id="element-31" data-mp="2k1cdgtaj1or">
                <GiftIcon className="w-6 h-6 text-brand-green" aria-hidden="true" data-id="element-32" data-mp="cjs5be27d8mq" />
              </span>
              <div className="flex-1" data-id="element-33" data-mp="gk2j3cw8l3c5">
                <h3 className="font-bold text-brand-text text-sm md:text-base mb-1" data-id="element-34" data-mp="lc3tsudram02">
                  {bonus}
                </h3>
                <div className="flex items-center gap-2 text-xs md:text-sm" data-id="element-35" data-mp="qbgf3aozbl0j">
                  <span className="text-brand-terracotta line-through font-medium" data-id="element-36" data-mp="vajlaygp3xa3">
                    {pricing.bonusUnitValue}
                  </span>
                  <span className="text-brand-green font-bold" data-id="element-37" data-mp="109w51ac9so8g">GRATIS</span>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}